import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Search } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';

@Component({
  selector: 'app-scheme-creation-grid',
  templateUrl: './scheme-creation-grid.component.html',
  styleUrls: ['./scheme-creation-grid.component.css']
})
export class SchemeCreationGridComponent implements OnInit {


  title="Scheme Creation";

  
  itemsPerPage: number=5;
  currentPage: number=1;
  data : any = {};  
  totalItems : number;
  s: Search;
  isSearch:boolean = false;
  AGENT_ID : number;
  SchemeDetailsList: any = {};
  logbranch:any;
  userService: any;

  constructor(private Service: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
   }

  ngOnInit() {
   this.GetSchemeDetails(this.itemsPerPage, 1)
  }



  

  GetSchemeDetails(itemsPerPage:any,pageNo:any){
    debugger;
  this.logbranch=localStorage.getItem('BRANCH_ID');
  
    this.data = this.Service.GetSchemeDetails(itemsPerPage,pageNo,this.logbranch);
    this.data.subscribe(
      (response: any) => {
        this.SchemeDetailsList = response.SchemeCreationModel;
          this.totalItems = response.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
        
        console.log(this.SchemeDetailsList);    
},
    )
}


delete(GLSUB_ID){
  


    
  debugger;


  
 swal({
    title: 'Are you sure?', text: "You want to delete!", type: 'warning',
     showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
     
      if (result.value) 
      {
      this.data = this.Service.DeleteScheme(GLSUB_ID);
      this.data.subscribe(
       (response: any) =>
        {
        this.GetSchemeDetails(this.itemsPerPage, 1)
                 
       },
        (error) => {
        
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
      
        }
      }    
    ); 
  } 
})
}




pageChanged(pageNumber: number) {
  if (this.isSearch)
    this.onSearch(this.s, this.itemsPerPage, pageNumber);
  else
    this.GetSchemeDetails(this.itemsPerPage, pageNumber);
}

itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
  if (this.isSearch)
    this.onSearch(this.s, this.itemsPerPage, pageNo);
  else
    this.GetSchemeDetails(this.itemsPerPage, pageNo);
}


//Search item


onSearch(s, itemsPerPage: number, pageNo: number) { 

debugger;
this.isSearch = true;
let searchText = this.s.SearchText;
let searchCriteria = this.s.SearchCriteria;
if (searchText == "" || searchText == null) 
   swal("Warning!", "Please enter the search text.", "warning");

 else if(searchCriteria == "" || searchCriteria == null)
 swal("Warning!", "Please enter the Search Criteria .", "warning");
else {
 
  this.Service.SearchScheme(searchCriteria, searchText, itemsPerPage, pageNo)
    .subscribe(
      (data: any) => {
        if(data.SchemeCreationModel.length!=0){              
        this.SchemeDetailsList = data.SchemeCreationModel;
        this.totalItems = data.TotalItemsCount;
        this.currentPage = pageNo;
        
      }
      else
      {
             
      }
      }, (error) => {
        
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          
        }
      });
}
}

}



// WEBPACK FOOTER //
// ./src/app/unicore-masters/scheme-creation/scheme-creation-grid/scheme-creation-grid.component.ts